import makeAjaxRequest from "helpers/makeAjaxRequest";
import { toggleExpandedTree, transformBool } from "helpers/utils";
import * as R from "ramda";
import {
  FETCH_INSTITUION_ATTRIBUTES,
  FETCH_INSTITUTION_ADDRESS_DATA,
  FETCH_INSTITUTION_AFFLIATIONS,
  FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA,
  FETCH_INSTITUTION_CONTACTS_DATA,
  FETCH_INSTITUTION_SITE_RESTRICTIONS_DATA,
  FETCH_INSTITUTION_TREE_DETAILS,
  SAVE_INSTITUTION_JOB_ID,
  SAVE_SELECTED_INSTITUTION_DATA
} from "../types";

import {
  rosterNumUrl,
  rosterUrl,
  sitesDataService,
  sitesDataServiceCore,
  sitesUrl,
  sitesUrlBase,
  userDataServiceUrl
} from "../constants";

// look up institution

export const queryInsitutionDetails = req => async dispatch => {
  const response = dispatch({
    type: SAVE_SELECTED_INSTITUTION_DATA,
    payload: makeAjaxRequest.postWithAuth(`${sitesDataServiceCore}/search`, req).then(data => (data[0] ? data[0] : req))
  });
  response.then(({ value }) => {
    dispatch({
      type: FETCH_INSTITUTION_AFFLIATIONS,
      payload: makeAjaxRequest.fetchWithAuth(`${sitesDataService}/${value.siteCtepId}/affiliation/details`)
    });
  });
};

export const fetchInstitutionTreeData = (ctepId, userGroup) => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_TREE_DETAILS,
    payload: makeAjaxRequest.fetchWithAuth(`${sitesUrl}/${ctepId}/tree/CTSU`).then(response =>
      toggleExpandedTree(response, userGroup)
    )
  });
};

export const fetchInstitutionAssociatedProviders = irostId => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA,
    payload: makeAjaxRequest.postWithAuth(`${rosterNumUrl}/${irostId}/associated/providers`, {}) // send body as empty otherwise api will throw bad request
  });
};

export const fetchInstitutionSiteRestrictions = ctepId => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_SITE_RESTRICTIONS_DATA,
    payload: makeAjaxRequest.postWithAuth(`${sitesDataService}/${ctepId}/siterestrictions`, {})
  });
};

export const fetchInstitutionAddressData = Ognid => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_ADDRESS_DATA,
    payload: makeAjaxRequest.fetchWithAuth(`${rosterUrl}/id/${Ognid}/address`).then(response => {
      const data = transformBool(response);
      return R.sortWith([R.descend(R.prop("preferred")), R.ascend(R.prop("infoSource"))])(data);
    })
  });
};

export const fetchInstitutionContactssData = Ognid => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_CONTACTS_DATA,
    payload: makeAjaxRequest.fetchWithAuth(`${rosterUrl}/id/${Ognid}/contacts`).then(response => {
      const onlyActive = response.filter(res => res.contactStatus === "Active");
      const data = transformBool(onlyActive);
      return R.sortWith([R.descend(R.prop("preferred")), R.ascend(R.prop("infoSource"))])(data);
    })
  });
};

export const saveSelectedInstitution = (data, callback) => async dispatch => {
  const response = dispatch({
    type: SAVE_SELECTED_INSTITUTION_DATA,
    payload: Promise.resolve(data)
  });
  response.then(() => {
    callback();
  });
};
export const saveInstitutionJobId = data => async dispatch => {
  const response = dispatch({
    type: SAVE_INSTITUTION_JOB_ID,
    payload: Promise.resolve(data)
  });
  response.then(() => makeAjaxRequest.put(userDataServiceUrl, { ...data }));
};

// Institution Attributes

export const fetchInstitutionAttributes = (siteCtepId, orgId, userGroup) => async dispatch => {
  if (!siteCtepId) {
    return;
  }
  const body = {
    ognId: orgId,
    userGroup,
    infoSource: orgId,
    instRosterId: null
  };
  dispatch({
    type: FETCH_INSTITUION_ATTRIBUTES,
    payload: makeAjaxRequest.postWithAuth(`${sitesUrlBase}/${siteCtepId}/attributes`, body)
  });
};
